<template>
  <transition name="loading-fade">
    <div v-if="visible" class="aj-loading-mask" :class="{ 'aj-loading--fullscreen': fullscreen }">
      <div class="aj-loading-content">
        <!-- 旋转圆环加载器 -->
        <div class="aj-loading-spinner">
          <svg class="aj-loading-circle" viewBox="0 0 50 50">
            <circle class="aj-loading-path" cx="25" cy="25" r="20" fill="none" stroke-width="3"></circle>
          </svg>
          <svg class="aj-loading-icon" viewBox="0 0 50 50">
            <circle class="aj-loading-dot" cx="25" cy="25" r="6" fill="#409EFF"></circle>
          </svg>
        </div>
        <!-- 加载文字 -->
        <p v-if="text" class="aj-loading-text">{{ text }}</p>
        <!-- 进度条 -->
        <div v-if="progress > 0" class="aj-loading-progress">
          <div class="aj-loading-progress-bar" :style="{ width: progress + '%' }"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AjLoading',
  props: {
    // 加载文字
    text: {
      type: String,
      default: '加载中...'
    },
    // 是否全屏显示
    fullscreen: {
      type: Boolean,
      default: true
    },
    // 进度（0-100）
    progress: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    // 显示loading
    open(options = {}) {
      if (typeof options === 'string') {
        this.text = options
      } else {
        this.text = options.text || '加载中...'
        this.fullscreen = options.fullscreen !== undefined ? options.fullscreen : true
        this.progress = options.progress || 0
      }
      this.visible = true
    },
    // 关闭loading
    close() {
      this.visible = false
    },
    // 设置进度
    setProgress(value) {
      this.progress = Math.min(100, Math.max(0, value))
    }
  }
}
</script>

<style scoped>
/* 遮罩层 */
.aj-loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.aj-loading-mask.aj-loading--fullscreen {
  position: fixed;
}

/* 内容区域 */
.aj-loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 50px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

/* 旋转圆环 */
.aj-loading-spinner {
  position: relative;
  width: 60px;
  height: 60px;
}

.aj-loading-circle {
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite;
}

.aj-loading-path {
  stroke: #e8e8e8;
  stroke-linecap: round;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
}

.aj-loading-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  animation: rotate 2s linear infinite reverse;
}

.aj-loading-dot {
  animation: dotPulse 1s ease-in-out infinite;
}

/* 加载文字 */
.aj-loading-text {
  margin-top: 16px;
  font-size: 14px;
  color: #666;
  text-align: center;
}

/* 进度条 */
.aj-loading-progress {
  width: 120px;
  height: 4px;
  margin-top: 12px;
  background: #e8e8e8;
  border-radius: 2px;
  overflow: hidden;
}

.aj-loading-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #409EFF, #67C23A);
  border-radius: 2px;
  transition: width 0.3s ease;
}

/* 动画 */
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@keyframes dotPulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.8);
    opacity: 0.7;
  }
}

/* 过渡效果 */
.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.3s ease;
}

.loading-fade-enter,
.loading-fade-leave-to {
  opacity: 0;
}
</style>
